// react
import { useRouter } from "next/router";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal, showAppMessage } from "~/redux/actions/app";

import { Avatar } from "antd";

import { avatarUrl } from "~/utils/app";
import { userUrl } from "~/utils/route";
import UserBadge from "./UserBadge";
import { getUserBadge } from "~/utils/ui";

const UserAvatar = (props) => {
  const router = useRouter();

  const handleLinkToUser = (id) => {
    router.push(`/users/${id}`);
  };

  return (
    <div
      onClick={handleLinkToUser.bind(null, props.user.id)}
      style={{ display: "inline-block" }}
    >
      <div style={{ display: "inline-block",cursor: "pointer", ...props.style }}>
        <div style={{ position: "relative" }}>
          <Avatar
            alt="头像"
            style={
              getUserBadge(props.user, "UserAvatar", props.size)
                .avatarBorderStyle
            }
            src={avatarUrl(props.user, 64)}
            size={props.size}
          />
          <UserBadge user={props.user} avatarSize={props.size} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
      showAppMessage,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserAvatar);
